import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import React from "react";
import { DatePicker, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { DataGrid } from "@mui/x-data-grid";
import Notes from "../notes";

const EditModal = ({
  selectedRow,
  onClose,
  status,
  setStatus,
  outreachStatus,
  setOutreachStatus,
  aptDate,
  setAptDate,
  aptTime,
  setAptTime,
  gridColumns,
  loading,
  loadingTable,
  onSave,
}) => {
  return (
    <Dialog open={selectedRow} onClose={onClose} fullWidth maxWidth={false}>
      <DialogTitle>Edit Details</DialogTitle>

      <Box display="flex" alignItems="center" gap={2} ml={3}>
        <FormControl variant="outlined" size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Status</InputLabel>
          <Select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            label="Status"
            // disabled={isUpdateDisabled}
          >
            <MenuItem value="Open">Open</MenuItem>
            <MenuItem value="In-Progress">In-Progress</MenuItem>
            <MenuItem value="Closed">Closed</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" size="small" sx={{ minWidth: 200 }}>
          <InputLabel>Outreach Status</InputLabel>
          <Select
            value={outreachStatus}
            onChange={(e) => setOutreachStatus(e.target.value)}
            label="Status"
            // disabled={isUpdateDisabled}
          >
            <MenuItem value="Appointment Scheduled">
              Appointment Scheduled
            </MenuItem>
            <MenuItem value="Unable to reach">Unable to reach</MenuItem>
            <MenuItem value="Left Voicemail (VMX)">
              Left Voicemail (VMX)
            </MenuItem>
            <MenuItem value="Declined">Declined</MenuItem>
            <MenuItem value="Requires Reachout Again">
              Requires Reachout Again
            </MenuItem>
          </Select>
        </FormControl>
        <DatePicker
          value={dayjs(aptDate)}
          onChange={(e) => setAptDate(e)}
          maxDate={dayjs()}
          format="YYYY-MM-DD"
          label="Scheduled Appointment Date"
          slotProps={{ textField: { variant: "standard", error: false } }}
        />
        <TimePicker
          value={dayjs(aptTime)}
          onChange={(e) => setAptTime(e)}
          label="Scheduled Appointment Time"
          format="hh:mm A"
          slotProps={{ textField: { variant: "standard", error: false } }}
        />
      </Box>
      <DialogContent>
        <DataGrid
          rows={[selectedRow]}
          columns={gridColumns}
          loading={loadingTable}
          columnVisibilityModel={{
            edit: false,
          }}
          disableRowSelectionOnClick
          pagination
          getRowId={(row) => row?.patient_id || "1"}
          hideFooterPagination
        />
      </DialogContent>
      <DialogContent>
        <Notes details={selectedRow} />
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={onClose} color="primary">
          Close
        </Button>
        <Button onClick={onSave} disabled={loading} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditModal;
